import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Usuario } from 'app/main/models/usuario.model';
import { UsersService } from '../../../services/users.service';
import {TranslateService} from '@ngx-translate/core';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-dialog-box',
  templateUrl: './user-select-dialog-box.component.html',
  styleUrls: ['./user-select-dialog-box.component.scss']
})

export class SelectDuenoDialogBoxComponent {

  nombreDueno="";
  usuario : Usuario = null;
  usuarios: Usuario[] = [];
  tipo: String;
  action: string;
  LOCAL_DATA: any;

  constructor(
    public dialogRef: MatDialogRef<SelectDuenoDialogBoxComponent>,
    private usuariosService: UsersService,
    public translate: TranslateService,
    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
      this.action = data.action;
      this.tipo = data.tipo;
      this.nombreDueno = data.nombre;
      this.usuarios = [];
      if(data.usuarios!=null){
        data.usuarios.forEach(element => {
          if(this.esOwnersGroup(element))
            this.usuarios.push(element);
        });
      }
  }

  doAction(): void{
    console.log('im here');
    this.dialogRef.close({event: this.action , data: this.usuario});
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

  }

  esOwnersGroup(usuario):boolean{

    var esOwner:boolean = false;

    usuario.tipos.forEach(element => {
      if(element.id == this.tipo)
        esOwner = true;
    });

    return esOwner;
  }

}
